export enum EAnticipationStatus {
  LIBERADO = 'liberado',
  BLOQUEADO = 'bloqueado',
  ALERTA = 'alerta',
}

interface IUser {
  id: string;
  name: string;
  full_name: string;
  producer: boolean;
  show_legal_person_card: boolean;
  affiliate: boolean;
  coproducer: boolean;
  email: string;
  beta_customer: boolean;
  type: string;
  photo: string;
  eadCharging: boolean;
  newbie: boolean;
  is_support: boolean;
  support_id: number;
  is_elite: boolean;
  is_clube_black: boolean;
  has_launch_export: boolean;
  has_transfer: boolean;
  document: string;
  partial_refund: string;
  coupom_batch: string;
  crossborder: boolean;
  invoice_transfer: boolean;
  current_elite_level: any;
  has_chat_black: boolean;
  not_recovering: number;
  new_anticipation_transfer: boolean;
  subscription_physical: boolean;
  fiscal_responsibility: boolean;
  general_term: boolean;
  acceptence_terms: boolean;
  negociate_invoice: boolean;
  create_new_account_bank: boolean;
  overdue_limit: boolean;
  international_account: boolean;
  anticipation_status: EAnticipationStatus;
  anticipation_status_message: string;
  eligible: boolean;

  isProducer(): boolean;
  isAffiliate(): boolean;
  isCustomer(): boolean;
  isCoproducer(): boolean;
}

export default IUser;
